export const ruTranslations = {
  // Russian translations
  'nav.home': 'Главная',
  'nav.findPlaces': 'Найти места',
  'nav.ratePlace': 'Оценить место',
  'nav.ratePlaces': 'Оценить места',
  'nav.login': 'Вход',
  'nav.signup': 'Регистрация',
  'nav.logout': 'Выйти',
  'nav.profile': 'Профиль',
  'nav.admin': 'Администрация',
  'nav.menu': 'Меню',
  'nav.account': 'Аккаунт',
  'nav.favorites': 'Ваши избранные',
  'favorites.description': 'Бизнесы, которые вы добавили в избранное',
  // Pagination
  'pagination.previous': 'Назад',
  'pagination.next': 'Далее',
  'pagination.goTo': 'Перейти к:',
  'pagination.go': 'Перейти',
  'pagination.of': 'из',
  'hero.title': 'Найди лучшее — избегай худшего!',
  'hero.subtitle': 'Проголосуй или найди свои любимые рестораны, спортзалы, развлекательные центры и многое другое, основываясь на реальном опыте клиентов, всего в один клик!',
  'cta.findPlaces': 'Найти места',
  'cta.ratePlace': 'Оценить место',
  'howItWorks.title': 'Как это работает',
  'howItWorks.step1': 'Найдите бизнес',
  'howItWorks.step2': 'Посмотрите голоса за и против',
  'howItWorks.step3': 'Оставьте свой голос',
  'featured.title': 'Избранные места',
  // Maintenance page
  'maintenance.title': 'Сайт на техническом обслуживании',
  'maintenance.defaultMain': 'Мы проводим улучшения и скоро вернемся онлайн!',
  'maintenance.thankYou': 'Спасибо за ваше терпение',
  // Filter translations
  'filters.categories': 'Категория',
  'filters.cities': 'Город',
  'filters.selected': 'выбрано',
  // Business card translations
  'businessCard.address': '{0}',
  'businessCard.hours': '{0}',
  'businessCard.phone': '{0}',
  'businessCard.full': 'полностью',
  'whyTrustUs.title': 'Почему нам можно доверять',
  'whyTrustUs.community': '100% создано сообществом',
  'whyTrustUs.realVotes': 'Никаких поддельных отзывов, только реальные голоса',
  'signup.title': 'Зарегистрируйте аккаунт',
  'signup.button': 'Присоединиться сейчас',
  'footer.quickLinks': 'Быстрые ссылки',
  'footer.information': 'Информация',
  'footer.about': 'О нас',
  'footer.contact': 'Контакт',
  'footer.reachOut': 'Связаться с нами',
  'buttons.viewDetails': 'Подробнее',
  'buttons.viewAll': 'Смотреть все',
  'buttons.refresh': 'Обновить',
  'buttons.viewAllPlaces': 'Посмотреть все места',
  'footer.terms': 'Условия использования',
  'footer.privacy': 'Политика конфиденциальности',
  'footer.rights': 'Все права защищены',
  'footer.socialNetworks': 'Социальные сети',
  
  // Profile page translations
  'profile.title': 'Профиль',
  'profile.accountInformation': 'Информация об аккаунте',
  'profile.email': 'Email',
  'profile.firstName': 'Имя',
  'profile.lastName': 'Фамилия',
  'profile.saveChanges': 'Сохранить изменения',
  'profile.saving': 'Сохранение...',
  'profile.validation.nameRequired': 'Имя или фамилия должны содержать минимум 3 буквы',
  'profile.validation.nameTaken': 'Это имя или фамилия уже используется. Пожалуйста, выберите другое.',
  'profile.validation.nameReserved': 'Это имя или фамилия зарезервированы и не могут быть использованы.',
  'profile.validation.nameBadWord': 'Имя или фамилия содержат недопустимые слова.',
  'profile.updateSuccess': 'Профиль обновлен',
  'profile.updateSuccessDescription': 'Ваш профиль успешно обновлен.',
  'profile.updateError': 'Ошибка',
  'profile.updateErrorDescription': 'Не удалось обновить профиль. Попробуйте снова.',
  'profile.accountActions': 'Действия с аккаунтом',
  'profile.signOutDescription': 'Если вы хотите выйти из своего аккаунта, нажмите кнопку ниже.',
  'profile.signOut': 'Выйти',
  'profile.yourActivity': 'Ваша активность',
  'profile.activityDescription': 'Просмотрите ваши голоса, оценки и отзывы',
  'profile.adminTools': 'Инструменты администратора',
  'profile.updateAdminProfiles': 'Обновить профили администраторов',
  
  // Auth translations
  'auth.signIn': 'Войти',
  'auth.signUp': 'Регистрация',
  'auth.signInWithGoogle': 'Войти через Google',
  'auth.email': 'Email',
  'auth.password': 'Пароль',
  'auth.error': 'Ошибка',
  'auth.success': 'Успех',
  'auth.loginDescription': 'Введите ваши данные для доступа к аккаунту',
  'auth.signupDescription': 'Создайте новый аккаунт, чтобы присоединиться к нашему сообществу',
  'auth.forgotPassword': 'Забыли пароль?',
  'auth.resetPassword': 'Сброс пароля',
  'auth.enterEmailForReset': 'Введите ваш email адрес и мы отправим вам ссылку для сброса пароля.',
  'auth.emailRequired': 'Email обязателен',
  'auth.emailNotRegistered': 'Этот email не зарегистрирован. Используйте email, с которым вы регистрировались.',
  'auth.resetEmailSent': 'Email для сброса пароля отправлен! Проверьте вашу почту.',
  'auth.emailSent': 'Email отправлен!',
  'auth.checkEmailInbox': 'Пожалуйста, проверьте вашу почту и следуйте инструкциям для сброса пароля.',
  'auth.close': 'Закрыть',
  'auth.sending': 'Отправка...',
  'auth.signingIn': 'Вход...',
  'auth.signingUp': 'Регистрация...',
  'auth.emailPlaceholder': 'ваш@email.com',
  'auth.fillAllFields': 'Пожалуйста, заполните все поля',
  'auth.accountCreated': 'Аккаунт успешно создан! Проверьте свою электронную почту для подтверждения.',
  'auth.loggedIn': 'Вход выполнен успешно!',
  'auth.failed': 'Ошибка авторизации',
  'auth.processing': 'Обработка...',
  'auth.noAccount': 'Нет аккаунта?',
  'auth.haveAccount': 'Уже есть аккаунт?',
  'auth.firstNameRequired': 'Имя обязательно',
  'auth.lastNameRequired': 'Фамилия обязательна',
  'auth.firstName': 'Имя',
  'auth.lastName': 'Фамилия',
  'auth.continueWith': 'ИЛИ ПРОДОЛЖИТЬ С',
  // Search translations
  'search.placeholder': 'Искать места...',
  'search.submit': 'Поиск',
  'search.byBusinessName': 'Поиск по названию бизнеса...',
  'search.businessesFound': 'Найдено {0} бизнесов',
  'search.showingOf': '(показано {0} из {1})',
  'search.showingBusinesses': 'Показано {0} из {1} бизнесов',
  'search.loadingBusinesses': 'Загрузка бизнесов...',
  'search.searchingBusinesses': 'Поиск бизнесов...',
  'search.loadingMoreBusinesses': 'Загрузка ещё бизнесов...',
  'search.nextBusinesses': 'Следующие 50 бизнесов',
  // Business list messages
  'businesses.noResults': 'Не найдено бизнесов, соответствующих выбранным фильтрам.',
  'businesses.loadError': 'Не удалось загрузить бизнесы. Пожалуйста, обновите страницу.',
  // Rating categories translations
  'rating.service': 'Обслуживание',
  'rating.cleanliness': 'Чистота',
  'rating.pricing': 'Цены',
  'rating.interior': 'Интерьер',
  // Business page translations
  'business.information': 'Информация о бизнесе',
  'business.reviews': 'Отзывы',
  'business.ratingsTitle': 'Рейтинги',
  'business.overallRating': 'Общий рейтинг',
  'business.ratingCategories': 'Категории рейтингов',
  'business.website': 'Вебсайт',
  'business.googleMaps': 'Смотреть в Google Maps',
  'business.placeOrder': 'Сделать заказ',
  'business.chooseDeliveryService': 'Выберите службу доставки',
  'business.performanceComparison': 'Сравнение производительности',
  'business.compareWith': 'Сравните этот бизнес со средним {0} в {1}',
  'business.basedOnBusinesses': 'на основе {0} бизнесов',
  'business.pricingNote': 'Примечание о ценах',
  'business.pricingExplanation': 'Более высокий рейтинг звезд указывает на лучшую воспринимаемую ценность/доступность',
  'business.cityAverage': 'Среднее по городу',
  'business.thisBusiness': 'Этот бизнес',
  // Weekdays
  'weekdays.monday': 'Понедельник',
  'weekdays.tuesday': 'Вторник',
  'weekdays.wednesday': 'Среда',
  'weekdays.thursday': 'Четверг',
  'weekdays.friday': 'Пятница',
  'weekdays.saturday': 'Суббота',
  'weekdays.sunday': 'Воскресенье',
  // Reviews translations
  'reviews.title': 'Отзывы',
  'reviews.googleReviews': 'Google отзывы',
  'reviews.noReviews': 'Отзывов пока нет',
  'reviews.showAll': 'Показать все отзывы',
  'reviews.writePlaceholder': 'Напишите отзыв...',
  'reviews.submit': 'Отправить отзыв',
  'reviews.viewMore': 'Посмотреть больше',
  'reviews.viewLess': 'Скрыть',
  // Activity tab translations
  'profile.upvotes': 'Положительные голоса',
  'profile.downvotes': 'Отрицательные голоса',
  // Loading messages
  'loading.default': 'Загрузка',
  'loading.favorites': 'Загрузка избранного',
  'loading.profile': 'Загрузка профиля',
  // Month abbreviations
  'months.jan': 'янв',
  'months.feb': 'фев',
  'months.mar': 'мар',
  'months.apr': 'апр',
  'months.may': 'май',
  'months.jun': 'июн',
  'months.jul': 'июл',
  'months.aug': 'авг',
  'months.sep': 'сен',
  'months.oct': 'окт',
  'months.nov': 'ноя',
  'months.dec': 'дек',
  // Rating popup translations
  'rating.rateThisBusiness': 'Оцените этот бизнес',
  'rating.guestNotice': 'Вы можете оценить как гость, но вход поможет нам предотвратить спам',
  'rating.doneRating': 'Готово',
  'rating.submitError': 'Не удалось отправить оценку',
  'rating.selectCategory': 'Пожалуйста, оцените хотя бы одну категорию',
  'rating.thankYou': 'Спасибо за ваши оценки!',
  'rating.yourRating': 'Ваша оценка',
  'rating.clickToRate': 'Нажмите для оценки',
  // Category translations for filters
  'categories.all': 'Все категории',
  'categories.restaurant': 'Ресторан',
  'categories.cafe': 'Кафе',
  'categories.bar': 'Бар',
  'categories.hotel': 'Отель',
  'categories.shopping': 'Шоппинг',
  'categories.generalShopping': 'Универсальный магазин',
  'categories.generalstore': 'Универсальный магазин',
  'categories.entertainment': 'Развлечения',
  'categories.health': 'Здоровье',
  'categories.beauty': 'Красота',
  'categories.education': 'Образование',
  'categories.transport': 'Транспорт',
  'categories.fastFood': 'Быстрое питание',
  'categories.gym': 'Спортзал',
  'categories.pub': 'Паб',
  'categories.electronicsStore': 'Магазин электроники',
  'categories.wellnessCenter': 'Велнес центр',
  'categories.shoppingMall': 'Торговый центр',
  'categories.movieTheater': 'Кинотеатр',
  'categories.hamburgerRestaurant': 'Ресторан гамбургеров',
  'categories.theater': 'Театр',
  'categories.puppetTheater': 'Кукольный театр',
  'categories.museum': 'Музей',
  'categories.confectioneryShop': 'Кондитерская',
  'categories.shawarmaRestaurant': 'Шаурма-ресторан',
  'categories.swimmingPool': 'Бассейн',
  'categories.bakery': 'Пекарня',
  'categories.supermarket': 'Супермаркет и Гипермаркет',
  'categories.supermarketandhypermarket': 'Супермаркет и Гипермаркет',
  'categories.iceCream': 'Мороженое',
  'categories.coffeeShop': 'Кофейня',
  'categories.sportsComplex': 'Спортивный комплекс',
  'categories.clothingStore': 'Магазин одежды',
  'categories.giftShop': 'Магазин подарков',
  'categories.toyStore': 'Магазин игрушек',
  'categories.market': 'Рынок',
  'categories.park': 'Парк',
  'categories.touristAttraction': 'Туристическая достопримечательность',
  'categories.winery': 'Винодельня',
  'categories.library': 'Библиотека',
  'categories.pizza': 'Пиццерия',
  'categories.homeGoodsStore': 'Магазин товаров для дома',
  'categories.buildingMaterialsStore': 'Магазин стройматериалов',
  'categories.automobile': 'Автомобили',
  'categories.parfumeandcosmetics': 'Парфюмерия и косметика',
  'categories.jewelryandaccessories': 'Ювелирные изделия и аксессуары',
  'categories.bookandstationery': 'Книги и канцтовары',
  'categories.alcoholandbeverages': 'Алкоголь и напитки',
  'categories.furnitureandtextiles': 'Мебель и текстиль',
  'categories.lighting': 'Освещение',
  // Lowercase category keys for radar chart
  'categories.hamburgerrestaurant': 'Ресторан гамбургеров',
  'categories.fastfood': 'Быстрое питание',
  'categories.icecream': 'Мороженое',
  'categories.coffeeshop': 'Кофейня',
  'categories.electronicsstore': 'Магазин электроники',
  'categories.wellnesscenter': 'Велнес центр',
  'categories.shoppingmall': 'Торговый центр',
  'categories.movietheater': 'Кинотеатр',
  'categories.confectioneryshop': 'Кондитерская',
  'categories.shawarmarestaurant': 'Шаурма-ресторан',
  'categories.swimmingpool': 'Бассейн',
  'categories.sportscomplex': 'Спортивный комплекс',
  'categories.clothingstore': 'Магазин одежды',
  'categories.giftshop': 'Магазин подарков',
  'categories.toystore': 'Магазин игрушек',
  'categories.touristattraction': 'Туристическая достопримечательность',
  'categories.homegoodsstore': 'Магазин товаров для дома',
  'categories.buildingmaterialsstore': 'Магазин стройматериалов',
  'categories.puppettheater': 'Кукольный театр',
  // City translations for filters
  'cities.tbilisi': 'Тбилиси',
  'cities.batumi': 'Батуми',
  'cities.kutaisi': 'Кутаиси',
  'cities.rustavi': 'Рустави',
  'cities.gori': 'Гори',
  'cities.zugdidi': 'Зугдиди',
  'cities.poti': 'Поти',
  'cities.telavi': 'Телави',
  'cities.mtskheta': 'Мцхета',
  'cities.borjomi': 'Боржоми',
  'cities.kobuleti': 'Кобулети',
  'cities.akhaltsikhe': 'Ахалцихе',
  'cities.sachkhere': 'Сачхере',
  'cities.samtredia': 'Самтредиа',
  'cities.senaki': 'Сенаки',
  'cities.khashuri': 'Хашури',
  'cities.chiatura': 'Чиатура',
  'cities.kvariati': 'Квариати',
  'cities.baghdati': 'Багдати',
  'cities.sairme': 'Саирме',
  'cities.kaspi': 'Каспи',
  'cities.tsalka': 'Цалка',
  'cities.tsalenjikha': 'Цаленджиха',
  'cities.tskaltubo': 'Цкалтубо',
  'cities.khoni': 'Хони',
  'cities.martvili': 'Мартвили',
  'cities.vani': 'Вани',
  'cities.kareli': 'Карели',
  'cities.marneuli': 'Марнеули',
  'cities.lanchkhuti': 'Ланчхути',
  'cities.shekvetili': 'Шекветили',
  'cities.chkhorotsku': 'Чхороцку',
  'cities.ureki': 'Уреки',
  'cities.gonio': 'Гонио',
  'cities.anaklia': 'Анаклия',
  'cities.ushguli': 'Ушгули',
  'cities.lentekhi': 'Лентехи',
  'cities.tsageri': 'Цагери',
  'cities.akhalkalaki': 'Ахалкалаки',
  'cities.dusheti': 'Душети',
  'cities.saguramo': 'Сагурамо',
  'cities.tianeti': 'Тианети',
  'cities.akhmeta': 'Ахмета',
  'cities.sagarejo': 'Сагареджо',
  'cities.sighnaghi': 'Сигнаги',
  'cities.kvareli': 'Кварели',
  'cities.gurjaani': 'Гурджаани',
  'cities.lagodekhi': 'Лагодехи',
  'cities.dedoplistskaro': 'Дедоплисцкаро',
  'cities.ninotsminda': 'Ниноцминда',
  'cities.dmanisi': 'Дманиси',
  'cities.bolnisi': 'Болниси',
  'cities.gardabani': 'Гардабани',
  'cities.abasha': 'Абаша',
  'cities.tkibuli': 'Ткибули',
  'cities.bakhmaro': 'Бахмаро',
  'cities.chokhatauri': 'Чохатаури',
  'cities.shuakhevi': 'Шуахеви',
  'cities.keda': 'Кеда',
  'cities.khulo': 'Хуло',
  'cities.manglisi': 'Манглиси',
  // Missing cities previously without translations
  'cities.bakuriani': 'Бакуриани',
  'cities.gudauri': 'Гудаури',
  'cities.mestia': 'Местия',
  'cities.oni': 'Они',
  'cities.ozurgeti': 'Озургети',
  'cities.stepantsminda': 'Степанцминда',
  'cities.terjola': 'Терджола',
  'cities.zestafoni': 'Зестафони',
  'cities.ambrolauri': 'Амбролаури',
  'cities.natakhtari': 'Натахтари',
  // Review translations - additional
  'reviews.pleaseEnterReview': 'Пожалуйста, введите отзыв',
  'reviews.invalidReview': 'Неверный отзыв',
  'reviews.onlyBadWordsError': 'Отзыв не может содержать только неприемлемый контент',
  'reviews.spamContentError': 'Ваш отзыв содержит рекламный или спам-контент и не может быть отправлен.',
  'reviews.pleaseWait': 'Пожалуйста, подождите',
  'reviews.rateLimitError': 'Вы можете отправить новый отзыв через 30 секунд',
  'reviews.mustBeLoggedIn': 'Для отправки отзыва необходимо войти в систему',
  'reviews.duplicateReview': 'Дублированный отзыв',
  'reviews.somethingWentWrong': 'Что-то пошло не так.',
  'reviews.submitFailedTryAgain': 'Не удалось отправить отзыв, попробуйте еще раз.',
  'reviews.reviewSubmitted': 'Ваш отзыв отправлен',
  'reviews.submitFailed': 'Не удалось отправить отзыв',
  'reviews.spamWarning': 'Ваш отзыв содержит ссылку или рекламный контент.',
  'reviews.badWordsOnlyWarning': 'Отзыв не может содержать только неприемлемые слова.',
  'reviews.characterLimitReached': 'Достигнут максимальный лимит символов',
  'reviews.submitting': 'Отправка...',
  // Page content translations
  'pages.about.title': 'О нас',
  'pages.about.welcome': 'Добро пожаловать на GoodVote.ge – вашу платформу для поиска, изучения и оценки лучших предприятий в вашем районе.',
  'pages.about.belief': 'В GoodVote мы верим, что местные знания – это сила. Ищете ли вы уютное кафе, романтический ресторан или скрытую жемчужину в вашем городе, наша платформа поможет вам принимать уверенные решения.',
  'pages.about.description': 'Мы используем API бизнес-данных Google для предоставления актуальной информации о предприятиях, а затем даем вам, сообществу, возможность голосовать, оценивать и рекомендовать.',
  'pages.about.independence': 'GoodVote независимая и бесплатная платформа, созданная с учетом простоты. Мы не берем плату за доступ и не загромождаем ваш опыт платежами.',
  'pages.about.why.title': 'Почему мы существуем:',
  'pages.about.why.point1': 'Чтобы дать пользователям возможность делать лучший выбор в отношении местных услуг.',
  'pages.about.why.point2': 'Поддерживать местный бизнес, подчеркивая качество и прозрачность.',
  'pages.about.why.point3': 'Создать надежное пространство для отзывов без шума и предвзятости.',
  'pages.about.companion': 'Являетесь ли вы путешественником в новом городе или местным жителем, исследующим свой район, GoodVote.ge – ваш цифровой спутник.',
  'pages.contact.title': 'Свяжитесь с нами',
  'pages.contact.description': 'Есть вопросы, предложения или хотите связаться? Мы будем рады услышать от вас.',
  'pages.contact.button': 'Контакт',
  'pages.contact.emailLabel': 'Наш адрес электронной почты:',
  // Updated Terms of Service translations
  'pages.terms.title': 'Условия обслуживания GoodVote.ge',
  'pages.terms.effective': 'Дата вступления в силу: 19 июля 2025',
  'pages.terms.welcome': 'Добро пожаловать на GoodVote.ge! Используя наш веб-сайт, вы соглашаетесь со следующими Условиями обслуживания.',
  'pages.terms.use.title': '1. Использование нашего сервиса',
  'pages.terms.use.description': 'GoodVote.ge – это платформа для поиска и оценки местных предприятий.',
  'pages.terms.use.point1': 'Мы используем публичные API от Google и других источников для получения и отображения бизнес-данных. Мы не претендуем на владение этими данными.',
  'pages.terms.use.point2': 'Вы не можете использовать веб-сайт в незаконных, вредных или оскорбительных целях.',
  'pages.terms.use.point3': 'Вы не должны пытаться взломать, парсить или взламывать наши услуги.',
  'pages.terms.content.title': '2. Пользовательский контент',
  'pages.terms.content.point1': 'Пользователи могут отправлять отзывы, голоса и отзывы о предприятиях.',
  'pages.terms.content.point2': 'Вы несете ответственность за контент, который публикуете.',
  'pages.terms.content.point3': 'Мы можем удалить контент, который является оскорбительным, вводящим в заблуждение или нарушает законы.',
  'pages.terms.account.title': '3. Управление аккаунтом и вход',
  'pages.terms.account.point1': 'Некоторые функции, такие как отправка отзывов или сохранение избранного, могут потребовать входа в систему.',
  'pages.terms.account.point2': 'Вы несете ответственность за безопасность вашего аккаунта и любую деятельность под вашим аккаунтом.',
  'pages.terms.account.point3': 'Если вы выбираете регистрацию или вход через Google, вы соглашаетесь позволить нам использовать информацию вашего профиля Google (имя и email) для создания и управления вашим аккаунтом.',
  'pages.terms.account.point4': 'Вы не должны делиться своими учетными данными для входа или выдавать себя за другое лицо.',
  'pages.terms.ip.title': '4. Интеллектуальная собственность',
  'pages.terms.ip.point1': 'Весь код веб-сайта, дизайн и оригинальный контент принадлежат GoodVote.ge.',
  'pages.terms.ip.point2': 'Бизнес-данные Google, логотипы и другие торговые марки третьих лиц принадлежат их соответствующим владельцам.',
  'pages.terms.thirdparty.title': '5. Сторонние сервисы',
  'pages.terms.thirdparty.point1': 'Мы используем сторонние сервисы для работы нашего веб-сайта, включая Supabase для нашего бэкенда и аутентификации пользователей, и Google API для отображения бизнес-информации.',
  'pages.terms.thirdparty.point2': 'Мы не несем ответственности за точность или целостность данных от этих сторонних сервисов.',
  'pages.terms.thirdparty.point3': 'Ваше использование нашего сервиса также подчиняется условиям обслуживания наших сторонних поставщиков.',
  'pages.terms.liability.title': '6. Ограничение ответственности',
  'pages.terms.liability.point1': 'Мы не несем ответственности за любые убытки, возникшие в результате использования сайта.',
  'pages.terms.liability.point2': 'Сервис предоставляется "как есть" без каких-либо гарантий.',
  'pages.terms.changes.title': '7. Изменения в условиях',
  'pages.terms.changes.point1': 'Эти Условия обслуживания могут периодически обновляться. Мы уведомим вас о значительных изменениях, опубликовав новые условия на этой странице.',
  'pages.terms.changes.point2': 'Продолжение использования сайта после любых изменений означает принятие обновленных условий.',
  'pages.terms.termination.title': '8. Прекращение',
  'pages.terms.termination.description': 'Мы оставляем за собой право приостановить или прекратить ваш аккаунт и доступ к сервису по нашему единоличному усмотрению, без уведомления, за любое поведение, которое, по нашему мнению, нарушает эти Условия обслуживания или наносит вред другим пользователям сервиса или нам.',
  'pages.terms.contact.title': '9. Контакт',
  'pages.terms.contact.text': 'По вопросам об этих условиях пишите нам:',
  // Updated Privacy Policy translations
  'pages.privacy.title': 'Политика конфиденциальности GoodVote.ge',
  'pages.privacy.effective': 'Дата вступления в силу: 19 июля 2025',
  'pages.privacy.welcome': 'Добро пожаловать на GoodVote.ge! Эта политика конфиденциальности объясняет, как мы собираем, используем и защищаем вашу информацию.',
  'pages.privacy.collect.title': '1. Информация, которую мы собираем',
  'pages.privacy.collect.intro': 'Мы можем собирать:',
  'pages.privacy.collect.point1': 'Ваше имя и электронную почту (если вы создаете аккаунт или связываетесь с нами).',
  'pages.privacy.collect.point2': 'IP-адрес, тип браузера, информацию об устройстве (автоматически через cookies или логи).',
  'pages.privacy.collect.point3': 'Отзывы или голоса, которые вы отправляете.',
  'pages.privacy.collect.googleTitle': '1.1. Информация, собираемая при входе через Google',
  'pages.privacy.collect.googleDescription': 'Если вы выбираете регистрацию или вход через ваш Google аккаунт, вы предоставляете нам разрешение на доступ к определенной информации из вашего Google профиля.',
  'pages.privacy.collect.googleName': 'Ваше имя:',
  'pages.privacy.collect.googleNameDescription': 'Из области .../auth/userinfo.profile мы собираем ваше имя и фамилию для персонализации вашего аккаунта.',
  'pages.privacy.collect.googleEmail': 'Ваш адрес электронной почты:',
  'pages.privacy.collect.googleEmailDescription': 'Из области .../auth/userinfo.email мы собираем ваш основной адрес электронной почты.',
  'pages.privacy.collect.googleNote': 'Мы используем эту информацию для создания вашего пользовательского аккаунта и предварительного заполнения вашего профиля. Мы не получаем доступ, не храним и не делимся любой другой информацией из вашего Google аккаунта.',
  'pages.privacy.use.title': '2. Как мы используем вашу информацию',
  'pages.privacy.use.intro': 'Мы используем вашу информацию для:',
  'pages.privacy.use.point1': 'Предоставления и улучшения наших услуг.',
  'pages.privacy.use.point2': 'Отображения ваших отзывов и оценок в списках предприятий.',
  'pages.privacy.use.point3': 'Отправки уведомлений или обновлений (если вы согласились).',
  'pages.privacy.use.point4': 'Анализа моделей использования для улучшения пользовательского опыта.',
  'pages.privacy.use.point5': 'Для создания и управления вашим аккаунтом при входе через Google.',
  'pages.privacy.cookies.title': '3. Куки и отслеживание',
  'pages.privacy.cookies.text': 'Мы используем куки для улучшения функциональности сайта и аналитики.',
  'pages.privacy.thirdparty.title': '4. Сторонние сервисы',
  'pages.privacy.thirdparty.text': 'Мы можем использовать сторонние сервисы для помощи в работе нашего веб-сайта и сервисов.',
  'pages.privacy.thirdparty.supabase': 'Supabase:',
  'pages.privacy.thirdparty.supabaseDescription': 'Мы используем Supabase как поставщика бэкенд-сервиса. Данные вашего аккаунта, включая имя и email, безопасно хранятся на их платформе.',
  'pages.privacy.thirdparty.analytics': 'Google Analytics:',
  'pages.privacy.thirdparty.analyticsDescription': 'Мы используем Google Analytics для анализа использования веб-сайта.',
  'pages.privacy.sharing.title': '5. Обмен данными',
  'pages.privacy.sharing.intro': 'Мы не продаем вашу личную информацию. Мы можем делиться данными только в этих случаях:',
  'pages.privacy.sharing.point1': 'С вашего согласия.',
  'pages.privacy.sharing.point2': 'Для соблюдения законов или защиты наших прав.',
  'pages.privacy.sharing.point3': 'С перечисленными выше поставщиками сторонних услуг, которые помогают нам управлять сайтом.',
  'pages.privacy.security.title': '6. Безопасность данных',
  'pages.privacy.security.text': 'Мы принимаем разумные меры безопасности для защиты ваших данных, включая хранение вашей информации на безопасных платформах, таких как Supabase.',
  'pages.privacy.rights.title': '7. Ваши права',
  'pages.privacy.rights.description': 'У вас есть право на доступ, исправление или удаление ваших данных.',
  'pages.privacy.rights.point1': 'Вы можете управлять информацией своего профиля в настройках аккаунта.',
  'pages.privacy.rights.point2': 'Для запроса доступа, исправления или удаления ваших персональных данных обращайтесь к нам по адресу contact@goodvote.ge.',
  'pages.privacy.rights.point3': 'Вы можете отказаться от куки или аналитического отслеживания через настройки браузера.',
  'pages.privacy.changes.title': '8. Изменения в этой политике',
  'pages.privacy.changes.text': 'Эта Политика конфиденциальности может периодически обновляться. Мы будем размещать обновления на этой странице с новой датой вступления в силу.',
  'pages.privacy.contact.title': '9. Контакт',
  'pages.privacy.contact.text': 'Если у вас есть вопросы по этой Политике конфиденциальности или нашим методам работы с данными, свяжитесь с нами:',

  // Review reactions
  'reviews.like': 'Нравится',
  'reviews.dislike': 'Не нравится',
  'reviews.signInToReact': 'Пожалуйста, войдите, чтобы отреагировать на этот отзыв',
  'reviews.reactionError': 'Не удалось обновить реакцию',

  // Badges
  'badges.newbie': 'Новичок',
  'badges.explorer': 'Исследователь',
  'badges.helper': 'Помощник',
  'badges.trustedLocal': 'Доверенный местный',
  'badges.localExpert': 'Местный эксперт',
  'badges.cityMaster': 'Мастер города',
  'badges.countryMaster': 'Мастер страны',
  'badges.cleanlinessGuardian': 'Страж чистоты',
  'badges.priceScout': 'Ценовой разведчик',
  'badges.serviceJudge': 'Судья сервиса',
  'badges.interiorCritic': 'Критик интерьера',

  // Badge descriptions
  'badges.desc.newbie': 'От 1 до 9 отзывов/оценок',
  'badges.desc.explorer': 'От 10 до 29 отзывов/оценок',
  'badges.desc.helper': 'От 30 до 49 отзывов/оценок',
  'badges.desc.trustedLocal': 'От 50 до 99 отзывов/оценок',
  'badges.desc.localExpert': 'От 100 до 199 отзывов/оценок',
  'badges.desc.cityMaster': 'От 200 до 299 отзывов/оценок',
  'badges.desc.countryMaster': '300+ отзывов/оценок',
  'badges.desc.cleanlinessGuardian': '50+ оценок чистоты',
  'badges.desc.priceScout': '50+ оценок цен',
  'badges.desc.serviceJudge': '50+ оценок сервиса',
  'badges.desc.interiorCritic': '50+ оценок интерьера',

  // Badge requirements
  'badges.req.newbie': 'Оставьте от 1 до 9 отзывов',
  'badges.req.explorer': 'Оставьте от 10 до 29 отзывов',
  'badges.req.helper': 'Оставьте от 30 до 49 отзывов',
  'badges.req.trustedLocal': 'Оставьте от 50 до 99 отзывов',
  'badges.req.localExpert': 'Оставьте от 100 до 199 отзывов',
  'badges.req.cityMaster': 'Оставьте от 200 до 299 отзывов',
  'badges.req.countryMaster': 'Оставьте 300+ отзывов',
  'badges.req.cleanlinessGuardian': 'Оцените чистоту 50+ раз',
  'badges.req.priceScout': 'Оцените цены 50+ раз',
  'badges.req.serviceJudge': 'Оцените сервис 50+ раз',
  'badges.req.interiorCritic': 'Оцените интерьер 50+ раз',

  'badges.title': 'Ваши значки',
  'badges.allBadges': 'Все значки',
  'badges.infoSheet.title': 'Как заработать значки',
  'badges.progress': 'Прогресс',
  'badges.earned': 'Заработано',
  'badges.primaryBadges': 'Основные значки',
  'badges.specialtyBadges': 'Специальные значки',
  'badges.selectToDisplay': 'Выберите значок для отображения в отзывах',
  'badges.displayBadgeUpdated': 'Отображаемый значок обновлен',
  'badges.displayBadgeUpdatedDesc': 'Выбранный значок теперь будет отображаться во всех ваших отзывах',
  'badges.displayBadgeUpdateError': 'Не удалось обновить отображаемый значок',
  'badges.stats.current': 'Текущие отзывы -',
  'badges.stats.currentCleanliness': 'Текущие оценки чистоты -',
  'badges.stats.currentPricing': 'Текущие оценки цен -',
  'badges.stats.currentService': 'Текущие оценки сервиса -',
  'badges.stats.currentInterior': 'Текущие оценки интерьера -',
  
  // Earned badges section
  'badges.earnedBadges': 'Полученные значки',
  
  // Auth sign out messages
  'auth.signedOutSuccess': 'Вы успешно вышли',
  'auth.signOutError': 'Не удалось выйти. Попробуйте снова.',
  
  // Review toast messages
  'reviews.updateSuccess': 'Отзыв успешно обновлен',
  'reviews.updateError': 'Не удалось обновить отзыв',
  'reviews.deleteSuccess': 'Отзыв успешно удален',
  'reviews.deleteError': 'Не удалось удалить отзыв',
  'reviews.submitSuccess': 'Отзыв успешно отправлен!',
  
  // Delete confirmation dialog
  'dialog.areYouAbsolutelySure': 'Вы абсолютно уверены?',
  'dialog.deleteReviewWarning': 'Это действие нельзя отменить. Ваш отзыв будет удален навсегда.',
  'dialog.delete': 'Удалить',
  'dialog.cancel': 'Отмена',
  
  // Welcome toast and profile
  'auth.signedInSuccessfully': 'Вы успешно вошли',
  'auth.welcome': 'Добро пожаловать',
  'auth.dismiss': 'Закрыть',
  'profile.characters': 'символов',
};
